import { render } from "./AddInventaire.vue?vue&type=template&id=64dd4bba&scoped=true&ts=true"
import script from "./AddInventaire.vue?vue&type=script&lang=ts"
export * from "./AddInventaire.vue?vue&type=script&lang=ts"

import "./AddInventaire.vue?vue&type=style&index=0&id=64dd4bba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dd4bba"]])

export default __exports__